export enum ThemesEnum
{
    theme1 = 'Theme1'
}
